import React from 'react';
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../lib/types/AppState/index';
import { Modal, Button, Text, Group } from '@mantine/core';
import { ConfirmRemoveModalProps } from '../Types/BulkPricingTypes';
import { handleDeleteMatches } from '../utils';
import './OrgJobsPanel.scss';

const ConfirmRemoveModal: React.FC<ConfirmRemoveModalProps> = ({ 
    opened, onClose, selectedMatches, benchmarkYear, setSelectedMatches, setMatchDataLoading, updateMatchesInState, masterAccountID, orgJobs
}) => {

  const displayIn = useSelector((state: IAppState) => state.session.monetary_display);
  const handleConfirm = () => {
    handleDeleteMatches({ orgJobs, selectedMatches, benchmarkYear, setSelectedMatches, setMatchDataLoading, updateMatchesInState, masterAccountID, displayIn });
    onClose();
  };

  return (
    <Modal 
      opened={opened} 
      onClose={onClose} 
      title='Remove Survey Job Match'
      centered
      size='40%'
      styles={{ title: { fontSize: 'large', fontWeight: 600, marginBottom: 15, marginTop: 5 } }}
    >
      <Text mb={25} size='sm'>{`Are you sure you want to remove the selected ${selectedMatches.length === 1 ? 'match' : 'matches'}?`}</Text>
      <Group mt='md' justify='flex-end'>
        <Button variant='subtle' size='xl' fz='sm' color='skyblue' onClick={onClose}>Cancel</Button>
        <Button size='xl' fz='sm' onClick={handleConfirm}>
          {`Remove ${selectedMatches.length} ${selectedMatches.length === 1 ? 'match' : 'matches'}`}
        </Button>
      </Group>
    </Modal>
  );
};

export default ConfirmRemoveModal;